import { render } from "./UserCourses.vue?vue&type=template&id=5fd07786&scoped=true"
import script from "./UserCourses.vue?vue&type=script&lang=js"
export * from "./UserCourses.vue?vue&type=script&lang=js"

import "./UserCourses.vue?vue&type=style&index=0&id=5fd07786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd07786"]])

export default __exports__